import { Injectable } from '@angular/core';
import { take } from 'rxjs';
import { SalesforceMappingStoreService } from '../../../services/salesforce/salesforce-mapping-store.service';
import { IDocMergeAllowedEntitiesService } from './IDocMergeAllowedEntitiesService';

@Injectable({
  providedIn: 'root',
})
export class SalesforceDocMergeAllowedEntitiesService implements IDocMergeAllowedEntitiesService {
  constructor(private salesforceMappingStore: SalesforceMappingStoreService) {}

  // @TODO: change to only Doc Merge enabled entities
  getAllowedEntities(): string[] {
    const configuredObjects = this.salesforceMappingStore.getEnabledObjectNamesSnapshot();

    // Kick off a fetch if the snapshot is empty; current caller gets [] and won't apply filtering.
    if (configuredObjects.length === 0) {
      this.salesforceMappingStore.getEnabledMappings().pipe(take(1)).subscribe();
    }

    return configuredObjects;
  }
}
